<template>
  <div>
    <div>
      <el-row>
        <div style="margin-top: 10px; min-height: 200px;">
          <portal to="destination">
            <el-select id="rfcFilter" v-loading="tableLoader" element-loading-spinner="none" key="rfcMulti" v-model="reasonForChangeMultiSelect" placeholder="" :clearable="false" multiple :collapse-tags="true" @visible-change="handleRFCMultiSelect($event)" @remove-tag="handleRFCMultiSelect()">
              <el-option v-for="item in ipListMeta.reasonForChangeList" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </portal>
          <portal to="responseRequiredLast">
            <el-select id="rsFilter" v-loading="tableLoader" element-loading-spinner="none" key="rsMulti" v-model="responseRequiredMultiSelect" placeholder="" :clearable="false" multiple :collapse-tags="true" @visible-change="handleRSMultiSelect($event)" @remove-tag="handleRSMultiSelect()">
              <el-option v-for="item in ipListMeta.responseRequiredList" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </portal>

          <v-server-table class="hiaTable" id="coderReviewListGrid" ref="coderReviewListGrid" @loading="tableLoader = true" @loaded="tableLoader = false" :columns="columns" :options="options" v-loading="tableLoader" element-loading-spinner="nucleus-loader">
            <template slot="filter__reasonForChangeDesc">
              <portal-target name="destination"> </portal-target>
            </template>
            <template slot="filter__responseRequiredLast">
              <portal-target name="responseRequiredLast"> </portal-target>
            </template>
            <template slot="selected" slot-scope="props">
              <input type="checkbox" v-model="props.row.checked" @click="selectRecord(props.row, $event)" />
            </template>
            <template slot="patientNumber" slot-scope="props">
              <router-link :to="`/${currentClientId}/my-projects/inpatient/${props.row.drgTableId}`">{{ props.row.patientNumber }}</router-link>
            </template>
            <template slot="particleUrl" slot-scope="props">
              <div>
                <a :href="`${compParticleBaseUrl}/reviews/inpatient/${props.row.drgTableId}`" target="_new">{{ props.row.patientNumber }}</a>
              </div>
            </template>

            <template slot="dischargeDate" slot-scope="props">
              <div>
                {{ props.row.dischargeDate ? formatDate(props.row.dischargeDate) : '' }}
              </div>
            </template>
            <template slot="admitDate" slot-scope="props">
              <div>
                {{ props.row.admitDate ? formatDate(props.row.admitDate) : '' }}
              </div>
            </template>
            <template slot="reviewDate" slot-scope="props">
              <div>
                {{ props.row.reviewDate ? formatDate(props.row.reviewDate) : '' }}
              </div>
            </template>
            <template slot="level2ReasonForChage" slot-scope="props">
              <div>
                {{ props.row.reviewLevel !== 'Coding Review' ? props.row.level2ReasonForChage : '' }}
              </div>
            </template>
            <template slot="hasAP" slot-scope="props">
              <div v-if="props.row.hasAP != null">
                <center>
                  <i class="el-icon-check checkSize" :title="props.row.hasAP"></i>
                </center>
              </div>
            </template>
            <template slot="rebuttalDate" slot-scope="props">
              <div>
                {{ props.row.rebuttalDate ? formatDate(props.row.rebuttalDate) : '' }}
              </div>
            </template>
            <template slot="rebuttalDateLast" slot-scope="props">
              <div>
                {{ props.row.rebuttalDateLast ? formatDate(props.row.rebuttalDateLast) : '' }}
              </div>
            </template>
            <template slot="displayClientName" slot-scope="props">
              <div class="displayClientNameText" :title="props.row.displayClientName">
                {{ props.row.displayClientName }}
              </div>
            </template>
            <template slot="agreeWithCodesLast" slot-scope="props">
              <div style="display: flex; align-items: center;">
                <i v-if="props.row.agreeWithCodesLast" :style="`font-size: 18px;margin-right: 5px;color:${props.row.agreeWithCodesLast === 'Yes' ? `#67c23a` : `#e6a23c;`}`" :class="props.row.agreeWithCodesLast === 'Yes' ? `el-icon-circle-check` : `el-icon-warning-outline`"></i><span>{{ props.row.agreeWithCodesLast }}</span>
              </div>
            </template>
            <template slot="rebuttals" slot-scope="props">
              <div style="display: flex; align-items: center;">
                <i v-if="props.row.rebuttals.length" :style="`cursor: pointer;width: 100%; text-align: center; font-size: 18px;color:${props.row.responseRequiredLast === 'Completed' ? `#67c23a` : `#e6a23c;`}`" :class="props.row.responseRequiredLast === 'Completed' ? `el-icon-chat-line-round` : `el-icon-chat-dot-round`" @click="handleRebuttalDisplayModal(props.row)"></i>
              </div>
            </template>
          </v-server-table>
        </div>
      </el-row>
    </div>
    <div id="dialogs">
      <coderInpatientWorksheetModal v-if="showWorksheetModal" :drgTableId="worksheetDrgTableId" :showWorksheetModal="showWorksheetModal" @close="handleModalClose"> </coderInpatientWorksheetModal>
      <rebuttalDisplay :record="selectedRecord" :rebuttalDisplayModal="rebuttalDisplayModal" @close="rebuttalDisplayModal = false"></rebuttalDisplay>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

import dateHelper from '@/mixins/date-helper'
import hiaTable from '@/mixins/hiaTable'
import debounce from 'debounce'
import HiaAuthorization from '@/mixins/hiaAuthorization'
import rebuttalDisplay from '@/views/MyProjects/rebuttalDisplay'

export default {
  name: 'inpatientList',
  mixins: [dateHelper, hiaTable, HiaAuthorization],
  data() {
    return {
      theList: 200,
      showMassUpdateDialog: false,
      statsLoading: false,
      vueTables2Query: {},
      loading: true,
      showWorksheetModal: false,
      worksheetDrgTableId: null,
      filterCriteria: '',
      tableLoader: false,
      isActivated: true,
      reasonForChangeMultiSelect: [],
      reasonForChangeMultiSelectBackup: [],
      responseRequiredMultiSelect: [],
      responseRequiredMultiSelectBackup: [],
      columns: ['patientNumber', 'particleUrl', 'mrNumber', 'displayClientName', 'payorName', 'coder', 'dischargeDate', 'reasonForChangeDesc', 'originalDrg', 'newDrg', 'originalPoo', 'disposition', 'recommendedPatStatus', 'recommendedPoo', 'agreeWithCodesLast', 'rebuttals', 'responseRequiredLast'],
      options: {
        actionsPosition: 'right',
        requestFunction: data => {
          return this.requestData(data)
        },
        debounce: 600,
        filterByColumn: true,
        filterable: ['patientNumber', 'particleUrl', 'mrNumber', 'displayClientName', 'payorName', 'coder', 'dischargeDate', 'originalDrg', 'newDrg', 'originalPoo', 'disposition', 'recommendedPatStatus', 'recommendedPoo', 'rebuttals', 'agreeWithCodesLast'],
        listColumns: {
          reviewLevel: []
        },
        columnsClasses: {
          selected: 'selected',
          reasonForChangeDesc: 'reasonForChangeDesc',
          comments: 'customComments',
          delete: 'delete',
          particleUrl: 'hide',
          responseRequiredLast: 'responseRequiredLast',
          displayClientName: 'displayClientName'
        },
        headings: {
          selected: h => {
            return h('input', {
              attrs: {
                type: 'checkbox',
                id: 'selectAllCheckboxIpList'
              },
              on: {
                click: e => {
                  this.localselectAll(e.srcElement.checked)
                }
              },
              ref: 'selectAllCheckbox'
            })
          },
          patientNumber: 'Patient Number',
          // agreeWithCodes: 'Agree with Changes',
          finalOutcome: 'Final Outcome',
          patientType: 'Pat Type',
          status: 'Review Status',
          consultantNumber: 'Auditor',
          payorName: 'Payor',
          physicianName: 'Provider',
          dischargeDate: 'Discharge Date',
          reasonForChangeDesc: 'Reason F Change',
          originalDrg: 'Orig. DRG',
          newDrg: 'New DRG',
          patientAge: 'Age',
          originalPoo: 'POO',
          disposition: 'Pat Status',
          recommendedPatStatus: 'Rec Pat Status',
          ipreviewType: 'Review Type',
          excludeRecord: 'Exclude Record',
          dedicatedStaffReview: 'Dedicated Staff Review',
          recommendedPoo: 'Rec POO',
          subClientNumber: 'Sub Client',
          originalReviewer: 'Orig Reviewer',
          originalReviewDate: 'Orig Review Date',
          originalClientNumber: 'Orig Client',
          level2ReasonForChage: 'Lvl2 Reason F Change',
          level2Drg: 'Lvl2 DRG',
          level2PatientStatus: 'Lvl2 Pat Status',
          level2Poo: 'Lvl2 POO',
          reviewLevel: 'Review Level',
          cdiStaff: 'CDI Staff',
          comments: 'Comments',
          mrNumber: 'MR Number',
          recordStatus: 'Record Status',
          reviewDate: 'Review Date',
          rebuttalCount: 'Rebuttal Count',
          rebuttalActiveCount: 'Active Rebuttals',
          rebuttalRespondedCount: 'Completed Rebuttals',
          hasAP: 'Has Action Plan',
          auditResult: 'Audit Result',
          responseNeeded: 'Response Needed',
          responseCount: 'Response Count',
          rebuttalDate: 'Response Date',
          coder: 'Coder',
          agreeWithCodesLast: 'Agree With Findings',
          agreeWithGroupingLast: 'Agree With Grouping',
          responseRequiredLast: 'Response Status',
          rebuttalDateLast: 'Response Date',
          codesStatusLast: 'Codes Outcome',
          groupingStatusLast: 'Grouping Outcome',
          delete: '',
          particleUrl: 'Particle URL',
          displayClientName: 'Facility',
          rebuttals: 'View Rebuttals'
        },
        perPage: 25,
        texts: {
          filter: '',
          filterBy: '...'
        },
        highlightMatches: true,
        sortIcon: { is: 'none' }
        // columnsDropdown: true
      },
      selectedRecord: [],
      rebuttalDisplayModal: false
    }
  },
  methods: {
    ...mapActions('myProjects/', ['LOAD_REBUTTALS_IP_LIST_PAGINATED', 'RUN_IP_MASS_ACKNOWLEDGE_NO_CHANGES']),
    ...mapActions('dropdowns/', ['GET_DROPDOWNS', 'CONVERT_DROPDOWN_COLUMNFILTERARRAY']),
    ...mapMutations('inpatientReviews/', ['SET_IPLIST_SELECTED', 'CLEAR_IPLIST_SELECTED', 'SET_IPLIST_REFRESH_FUNC']),
    async requestData(data) {
      try {
        data.projectID = this.$route.params.id
        data.query.projectID = this.$route.params.id
        data.query.reasonForChangeMultiSelect = this.reasonForChangeMultiSelect
        data.query.responseRequiredMultiSelect = this.responseRequiredMultiSelect
        data.globalSearch = this.filterCriteria
        this.vueTables2Query = data
        this.statsLoading = true
        const resultArray = await this.LOAD_REBUTTALS_IP_LIST_PAGINATED(data)
        this.options.columnsClasses.particleUrl = this.documentManagerAdmin() ? '' : 'hide'
        this.statsLoading = false
        return resultArray
      } catch (err) {
        console.log(err)
      }
    },
    openWorksheetModal(row) {
      this.worksheetDrgTableId = row.drgTableId
      if (this.$route.query.id !== row.drgTableId) {
        this.$router.push({ query: { id: row.drgTableId } })
      }
      this.showWorksheetModal = true
    },
    getSelectedRecords() {
      const simpleArray = this.ipListSelected.map(y => y.drgTableId)
      return [...new Set(simpleArray)]
    },
    handleModalClose() {
      this.showWorksheetModal = false
      this.$router.push({ query: {} })
    },
    handleRFCMultiSelect(isOpenEvent) {
      if (isOpenEvent === true) {
        this.reasonForChangeMultiSelectBackup = JSON.parse(JSON.stringify(this.reasonForChangeMultiSelect))
        return
      }

      if (JSON.stringify(this.reasonForChangeMultiSelectBackup) !== JSON.stringify(this.reasonForChangeMultiSelect)) {
        this.$refs.coderReviewListGrid.getData()
        this.reasonForChangeMultiSelectBackup = JSON.parse(JSON.stringify(this.reasonForChangeMultiSelect))
      }
    },
    handleRSMultiSelect(isOpenEvent) {
      if (isOpenEvent === true) {
        this.responseRequiredMultiSelectBackup = JSON.parse(JSON.stringify(this.responseRequiredMultiSelect))
        return
      }

      if (JSON.stringify(this.responseRequiredMultiSelectBackup) !== JSON.stringify(this.responseRequiredMultiSelect)) {
        this.$refs.coderReviewListGrid.getData()
        this.responseRequiredMultiSelectBackup = JSON.parse(JSON.stringify(this.responseRequiredMultiSelect))
      }
    },
    async localselectAll(checked) {
      const table = this.$refs.coderReviewListGrid.$el
      const checkboxes = table.querySelectorAll('input[type ="checkbox"]')

      if (checked) {
        this.tableLoader = true
        await this.GET_IP_LIST_ALLIDS(this.vueTables2Query)
        for (let i = 0; i < checkboxes.length; i++) {
          checkboxes[i].checked = true
        }
        this.tableLoader = false
        // this.$refs.coderReviewListGrid.refresh()
      } else {
        this.CLEAR_IPLIST_SELECTED()
        for (let i = 0; i < checkboxes.length; i++) {
          checkboxes[i].checked = false
        }
        // this.$refs.coderReviewListGrid.refresh()
      }
    },
    runGlobalFilter: debounce(function() {
      this.$refs.coderReviewListGrid.getData()
    }, 400),
    async handleMassUpdate(massUpdateModel) {
      this.showMassUpdateDialog = false
      // this.localSelectAll(false) // clear all the selected checkboxes
      // this.$refs.coderReviewListGrid.getData()
    },
    runAcknowledgeNoChanges() {
      this.$confirm('Acknowledge No Changes for records without changes?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        const payload = {
          projectID: this.$route.params.id,
          rebuttalDate: new Date().toISOString()
        }
        this.tableLoader = true
        this.RUN_IP_MASS_ACKNOWLEDGE_NO_CHANGES(payload).then(
          () => {
            this.$refs.coderReviewListGrid.getData()
            this.tableLoader = false
            this.$message({
              message: 'Acknowledge No Changes Successful',
              type: 'success'
            })
          },
          error => {
            console.log(error)
            this.tableLoader = false
            const message = error.response.data.message || 'Acknowledge No Changes Error'
            this.$message({
              message: message,
              type: 'error'
            })
          }
        )
      })
    },
    handleRebuttalDisplayModal(row) {
      this.selectedRecord = row
      this.rebuttalDisplayModal = true
    }
  },
  computed: {
    ...mapState('user/', ['currentClient', 'currentClientName', 'currentClientId', 'clients', 'user']),
    ...mapState('inpatientReviews/', ['statistics', 'ipListSelected', 'ipListRecordValidations']),
    ...mapState('projects/', ['projectPK', 'project']),
    ...mapState('dropdowns/', ['dropdowns']),
    ...mapState('myProjects/', ['ipListStatistics', 'ipListMeta']),
    compParticleBaseUrl() {
      return process.env.VUE_APP_PARTICLE_BASE_URL
    }
    // ...mapState('profile/', ['userProfile'])
  },
  created: function() {
    // this.defaultColumns = JSON.parse(JSON.stringify(this.sortableColumns))
    // this.loading = true
  },
  mounted: function() {
    if (this.$route.query.id) {
      this.openWorksheetModal({ drgTableId: this.$route.query.id })
    }
  },
  activated: function() {
    if (this.$refs.coderReviewListGrid && !this.isActivated) {
      this.$refs.coderReviewListGrid.getData()
    }
    this.isActivated = true
  },
  deactivated: function() {
    this.isActivated = false
    this.localInpatientReviews = []
    // clear any old validation messages, validation messages can be left around because the form validation gets triggered natively by
    // the browser when users hit the enter key in the form
    if (this.$refs.addForm) {
      this.$refs.addForm.clearValidate()
    }
    // this.localselectAll(false)
    // this.CLEAR_IPLIST_SELECTED()
  },
  components: {
    rebuttalDisplay
  }
}
</script>

<style scoped>
.item {
  margin-top: 3px;
  margin-right: 35px;
}

.stats-loading {
  opacity: 0.5;
}

.stats .el-tag {
  background-color: transparent !important;
  color: #909399 !important;
  border-color: #e9e9eb !important;
}

.stats >>> .el-badge__content {
  background-color: #f4f4f5 !important;
  color: #303133 !important;
}

>>> .reasonForChangeDesc,
>>> .responseRequiredLast {
  min-width: 145px;
}

>>> .reasonForChangeDesc .el-tag,
>>> .responseRequiredLast .el-tag {
  max-width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
}

>>> .rfcFilter {
}

>>> .hide {
  display: none !important;
}

>>> .displayClientName {
  max-width: 100px;
}

>>> .displayClientNameText {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
